// 用于登录注册页面输入框获取焦点失去焦点改变样式
var keyA = "errShow";
var keyB = "errTxt";
function initControl(objects, type) {
  let styleControl = {};
  for (let keys in objects) {
    if (type === "Boolean") styleControl[keys] = false;
    if (type === "Object") {
      styleControl[keys] = {};
      styleControl[keys][keyA] = false;
      styleControl[keys][keyB] = "";
    }
  }
  return styleControl;
}
import {
  validataPhone,
  checkPhone,
  checkRealname,
  validataQQ,
  validataDrawPwd,
  validataEmail,
  checkOne,
  checkOne5,
  vrifyCode2,
  ValidateRequire,
  validataRealName,
} from "@/common/utils/validate.js";
export default (objects) => ({
  inject: ["parentRoot"],
  data() {
    return {
      keyA,
      keyB,
      styleControl: initControl(objects, "Boolean"),
      styleErrorControl: initControl(objects, "Object"),
    };
  },
  created() {},
  methods: {
    onfocusControl(v) {
      // 聚焦变化
      if (this.styleControl[v] !== undefined) this.styleControl[v] = true;
    },
    onblurControl(v) {
      // 失去焦点变化
      if (this.ruleForm[v].length > 0)
        this.$set(
          this.ruleForm,
          v,
          this.ruleForm[v].replace(/(^\s*)|(\s*$)/g, "")
        ); // 去掉前后空格
      if (
        this.styleControl[v] !== undefined &&
        !ValidateRequire(this.ruleForm[v]) &&
        this.ruleForm[v].length === 0
      )
        this.styleControl[v] = false;
      this.resetError(v);
    },
    initFormControl(v) {
      if (
        this.styleControl[v] !== undefined &&
        ValidateRequire(this.ruleForm[v])
      )
        this.styleControl[v] = true;
    },
    resetError(v) {
      // 设置错误状态
      // keyA, keyB
      if (ValidateRequire(this.ruleForm[v])) {
        const {
          userPlace,
          passwordPlace,
          verificationPlace,
          qqError,
          emailPlace,
          phoneTips,
          realNameTips,
        } = this.$t("register");
        switch (v) {
          case "username":
            this.styleErrorControl[v][this.keyA] = !checkOne5(
              this.ruleForm[v],
              false
            );
            this.styleErrorControl[v][this.keyB] = userPlace;
            break;
          case "phone":
            this.styleErrorControl[v][this.keyA] = !checkPhone(
              this.ruleForm[v],
              false
            );
            this.styleErrorControl[v][this.keyB] = "";
            break;
          case "password":
          case "repeatPassword":
            this.styleErrorControl[v][this.keyA] = !checkOne(
              this.ruleForm[v],
              false
            );
            this.styleErrorControl[v][this.keyB] = passwordPlace;
            if (!checkOne(this.ruleForm[v], false)) return;
            if (
              checkOne(this.ruleForm["password"], false) &&
              checkOne(this.ruleForm["repeatPassword"], false) &&
              this.ruleForm["password"] === this.ruleForm["repeatPassword"]
            ) {
              this.styleErrorControl["password"][this.keyA] = false;
              this.styleErrorControl["repeatPassword"][this.keyA] = false;
            }
            if (
              this.ruleForm["repeatPassword"] &&
              ValidateRequire(this.ruleForm["password"]) &&
              ValidateRequire(this.ruleForm["repeatPassword"]) &&
              this.ruleForm["password"] !== this.ruleForm["repeatPassword"]
            ) {
              // if (v === 'password') {
              //   this.styleErrorControl['password'][this.keyA] = true
              //   this.styleErrorControl['password'][this.keyB] = this.$t('Forms').newDiff
              // }
              // if (v === 'repeatPassword') {
              //   this.styleErrorControl['repeatPassword'][this.keyA] = true
              //   this.styleErrorControl['repeatPassword'][this.keyB] = this.$t('Forms').newDiff
              // }
              this.styleErrorControl["repeatPassword"][this.keyA] = true;
              this.styleErrorControl["repeatPassword"][this.keyB] =
                this.$t("Forms").newDiff;
              // if (checkOne(this.ruleForm['password']) && checkOne(this.ruleForm['repeatPassword'])) this.styleErrorControl[v][this.keyB] = this.$t('Forms').newDiff
            }
            break;
          case "vrifyCode":
            this.styleErrorControl[v][this.keyA] = !vrifyCode2.test(
              this.ruleForm[v]
            );
            this.styleErrorControl[v][this.keyB] = verificationPlace;
            break;
          case "qq":
            this.styleErrorControl[v][this.keyA] = !validataQQ(
              this.ruleForm[v],
              false
            );
            this.styleErrorControl[v][this.keyB] = qqError;
            break;
          case "email":
            this.styleErrorControl[v][this.keyA] = !validataEmail(
              this.ruleForm[v],
              false
            );
            this.styleErrorControl[v][this.keyB] = emailPlace;
            break;
          case "phone":
            this.styleErrorControl[v][this.keyA] = !checkPhone(
              this.ruleForm[v]
            );
            this.styleErrorControl[v][this.keyB] = phoneTips;
            break;
          case "realName":
            this.styleErrorControl[v][this.keyA] = !validataRealName(
              this.ruleForm[v]
            );
            this.styleErrorControl[v][this.keyB] = realNameTips;
            break;
          case "withdrawPassword":
            this.styleErrorControl[v][this.keyA] = !validataDrawPwd(
              this.ruleForm[v],
              false
            );
            this.styleErrorControl[v][this.keyB] =
              this.$t("Forms").drawPwdError;
            break;
          default:
            break;
        }
      } else {
        if (this.styleErrorControl[v][this.keyA] !== undefined)
          this.styleErrorControl[v][this.keyA] = false;
      }
    },
    changeLiveChat(show) {
      if (this.$route.path === "/home" || this.$route.path === "/Service") {
        let type = show ? "minimize" : "hide";
        if (window.LiveChatWidget) window.LiveChatWidget.call(type);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/pages/build800/views/mixins/formStyleChange.js